/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGameAdv.vue?vue&type=template&id=30420b06&scoped=true"
import script from "./popGameAdv.vue?vue&type=script&lang=js"
export * from "./popGameAdv.vue?vue&type=script&lang=js"
import style0 from "./popGameAdv.vue?vue&type=style&index=0&id=30420b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30420b06",
  null
  
)

export default component.exports